var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "bg-white p-4 rounded-md shadow mb-6"
  }, [_c('h2', {
    staticClass: "text-lg font-semibold mb-4"
  }, [_vm._v("Blast Notifikasi")]), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.sendBlast.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4"
  }, [_c('div', [_c('label', {
    staticClass: "block text-sm font-medium mb-1"
  }, [_vm._v("Judul")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.title,
      expression: "form.title"
    }],
    staticClass: "border border-gray-300 rounded-md px-3 py-2 w-full",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan judul notifikasi",
      "required": ""
    },
    domProps: {
      "value": _vm.form.title
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "title", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium mb-1"
  }, [_vm._v("Topik")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.topic,
      expression: "form.topic"
    }],
    staticClass: "border border-gray-300 rounded-md px-3 py-2 w-full",
    attrs: {
      "type": "text",
      "placeholder": "Misal: all, user, driver"
    },
    domProps: {
      "value": _vm.form.topic
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "topic", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium mb-1"
  }, [_vm._v("Pesan")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.body,
      expression: "form.body"
    }],
    staticClass: "border border-gray-300 rounded-md px-3 py-2 w-full",
    attrs: {
      "type": "text",
      "placeholder": "Isi pesan notifikasi",
      "required": ""
    },
    domProps: {
      "value": _vm.form.body
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "body", $event.target.value);
      }
    }
  })]), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium mb-1"
  }, [_vm._v("Route")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.route,
      expression: "form.route"
    }],
    staticClass: "border border-gray-300 rounded-md px-3 py-2 w-full",
    attrs: {
      "type": "text",
      "placeholder": "Isi router",
      "required": ""
    },
    domProps: {
      "value": _vm.form.route
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "route", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "flex justify-end mt-4"
  }, [_c('button', {
    staticClass: "bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? 'Mengirim...' : 'Kirim Notifikasi') + " ")])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }